// extracted by mini-css-extract-plugin
export var bubble = "_42-0";
export var container = "_42-f";
export var contrastBorder = "_42-g";
export var greyOut = "_42-2";
export var initialsColor0 = "_42-3";
export var initialsColor1 = "_42-4";
export var initialsColor10 = "_42-d";
export var initialsColor11 = "_42-e";
export var initialsColor2 = "_42-5";
export var initialsColor3 = "_42-6";
export var initialsColor4 = "_42-7";
export var initialsColor5 = "_42-8";
export var initialsColor6 = "_42-9";
export var initialsColor7 = "_42-a";
export var initialsColor8 = "_42-b";
export var initialsColor9 = "_42-c";
export var initialsWrapper = "_42-1";
export var large = "_42-l";
export var medium = "_42-k";
export var mediumSmall = "_42-j";
export var mediumSmallMedium = "_42-o";
export var micro = "_42-h";
export var small = "_42-i";
export var tiny = "_42-n";
export var xTiny = "_42-m";